'use client'

import './globals.css'
import '@code-hike/mdx/dist/index.css'
import React from 'react'
import { Public_Sans as PublicSans } from 'next/font/google'
import AppLayout, { AppProviders } from '@/components/Layout'

const publicSans = PublicSans({ subsets: ['latin'] })

const Document = ({ children }: { children: React.ReactNode }) => (
  <html lang='en'>
    <head>
      <title>Prisby.ai - Coding is over.</title>
      <meta name='description' content='Coding is over.' />
      <meta property='og:title' content='Prisby.ai' />
      <meta property='og:description' content='Coding is over.' />
      <meta property='og:image' content='/images/og-image.png' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content='Prisby.ai' />
      <meta name='twitter:description' content='Coding is over.' />
      <meta name='twitter:image' content='/images/og-image.png' />
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0'
      />
      <link rel='icon' href='/favicon.ico' />
    </head>
    <body className={publicSans.className}>
      <main>
        <AppProviders>
          <AppLayout>{children}</AppLayout>
        </AppProviders>
      </main>
    </body>
  </html>
)

export default Document
